import Layout from '@layout/Index'

export const permissionApply = [
  {
    path: '/permission-apply',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "permission-apply-table" */ './pages/PermissionApplyTable.vue'),
        name: '权限申请',
        meta: {
          title: '权限申请',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/permission-apply/permission-apply.route.js